import { render, staticRenderFns } from "./PerformsReportView.vue?vue&type=template&id=6dd77ffd&scoped=true"
import script from "./PerformsReportView.vue?vue&type=script&lang=js"
export * from "./PerformsReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd77ffd",
  null
  
)

export default component.exports